export const NB_WEEKS = 6;
export const NB_DAYS = 7;
export const NB_TILES = 42;
export const EXAMINE_MODULE_NOT_ACTIVATED = "1";